<p class="text-muted text-sm">{{title}}</p>
<div class="flex justify-between items-center">
    <div class="bg-gray-300 w-40 relative h-1 rounded-sm">
        <div class="top-0 right-0 absolute bg-blue-500 h-full rounded-sm duration-200 transition-all" 
        [ngClass]="{'smoothfillUp': hasAnimation }"
        [style.width]="(+progressValue * 100) / +max
        + '%'"></div>
    </div>
    <div class="text-muted text-sm mr-2">{{score}}</div>
</div>

